import React from "react";
import { TableHead, TableRow, TableCell, IconButton } from "@mui/material";
import AddNewIcon from "../../Images/AddNew.png";
import { TABLE_STYLES } from "./addDeductTaxUtils";

/**
 * Shared table header for Additions/Deductions and Taxes tables.
 * Eliminates duplicate JSX between AddDedTableHead and TaxTableHead.
 *
 * @param {string} title - Header label for the first column (e.g. "Additions/Deduction" or "EE & ER Taxes")
 * @param {boolean} showItemColumn - Whether to display the imported item column
 * @param {boolean} isReadOnly - Whether editing is disabled
 * @param {Function} onAddRow - Callback to add a new row
 */
const AddDeductTaxTableHead = React.memo(function AddDeductTaxTableHead({
    title,
    showItemColumn,
    isReadOnly,
    onAddRow,
}) {
    return (
        <TableHead sx={TABLE_STYLES.tableHead}>
            <TableRow sx={{ fontSize: "0.75rem", fontWeight: 600, whiteSpace: "nowrap", height: "35px" }}>
                <TableCell
                    sx={{ backgroundColor: "#f6e0c2", width: showItemColumn ? "20%" : "30%", color: "#b8741a !important", p: "5px" }}
                    title={title}
                >
                    {title}
                </TableCell>
                {showItemColumn && (
                    <TableCell
                        sx={{ backgroundColor: "#f6e0c2", width: "20%", color: "#b8741a !important", p: "5px" }}
                        title="Item"
                    >
                        Item
                    </TableCell>
                )}
                <TableCell
                    sx={{ backgroundColor: "#f6e0c2", width: showItemColumn ? "15%" : "25%", color: "#b8741a !important", p: "5px" }}
                    title={showItemColumn ? "Mapped to" : "Item"}
                >
                    {showItemColumn ? "Mapped to" : "Item"}
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f2f2f2", width: "20%", p: "5px" }} title="COA">
                    COA
                </TableCell>
                <TableCell sx={{ backgroundColor: "#f2f2f2", width: "15%", p: "5px" }} title="Amount">
                    Amount
                </TableCell>
                <TableCell align="center" sx={{ backgroundColor: "#f2f2f2", p: "5px", width: "10%" }} title="Action">
                    <IconButton size="small" disabled={isReadOnly} onClick={onAddRow}>
                        <img src={AddNewIcon} alt="Add new" height={20} width={20} />
                    </IconButton>
                </TableCell>
            </TableRow>
        </TableHead>
    );
});

export default AddDeductTaxTableHead;
